/*
 * Created Date: 18-01-2024, 9:08:46 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { FormHelperText, InputLabel } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { useController } from 'react-hook-form'
import OTPInput from 'react-otp-input'

const CoreOtpInput = props => {
	const {
		name,
		control,
		rules,
		defaultValue,
		label,
		numInputs,
		renderSeparator,
		containerStyle,
		containerProps,
		...restProps
	} = props

	const {
		field: { value, onChange, ref },
		fieldState: { error }
	} = useController({
		name,
		control,
		rules,
		defaultValue
	})
	return (
		<div {...containerProps}>
			{label ? (
				<InputLabel required shrink htmlFor={name} className="text-[1rem] md:text-12 font-medium text-label ">
					{label}
				</InputLabel>
			) : null}
			<OTPInput
				value={value}
				onChange={onChange}
				numInputs={numInputs}
				containerStyle={containerStyle ?? { className: 'w-full' }}
				renderSeparator={renderSeparator ?? <span className="w-[1rem]" />}
				renderInput={props => (
					<input
						{...props}
						className="min-w-[4rem] text-[1.5rem] text-mainBlue font-bold aspect-square outline-none rounded-md border border-solid border-[#D3D7EA]"
					/>
				)}
				{...restProps}
			/>
			{error && error.message && <FormHelperText error={!!error}>{error.message}</FormHelperText>}
		</div>
	)
}

CoreOtpInput.defaultProps = {
	name: null,
	control: null,
	numInputs: 6,
	containerProps: null,
	containerStyle: {}
}

CoreOtpInput.propTypes = {
	name: PropTypes.string,
	control: PropTypes.object,
	rules: PropTypes.any,
	numInputs: PropTypes.number,
	renderInput: PropTypes.func,
	renderSeparator: PropTypes.func,
	label: PropTypes.node,
	containerProps: PropTypes.object,
	containerStyle: PropTypes.object || PropTypes.string
}

export default React.memo(CoreOtpInput)
